export default __webpack_public_path__ + "static/media/circle.0bb56df0.svg";